import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../i18n/LanguageContext';
import { Separator } from './ui/separator';

export function Footer() {
  const { t } = useLanguage();

  const legalLinks = [
    { key: 'legal_privacy_policy', href: '/privacy-policy', testId: 'footer-link-privacy-policy' },
    { key: 'legal_legal_notice', href: '/legal-notice', testId: 'footer-link-legal-notice' },
    { key: 'legal_cookie_policy', href: '/cookie-policy', testId: 'footer-link-cookie-policy' },
  ];

  const handleResetConsent = (e) => {
    e.preventDefault();
    try {
      localStorage.removeItem('sv_consent');
    } catch (_) { /* ignore */ }
    // Opt PostHog out of further capture if it was initialized this session.
    if (typeof window !== 'undefined' && window.posthog && typeof window.posthog.opt_out_capturing === 'function') {
      try { window.posthog.opt_out_capturing(); } catch (_) { /* ignore */ }
    }
    // Hard reload so the cookie banner re-appears with a fresh consent state.
    window.location.reload();
  };

  return (
    <footer className="bg-[#142235] text-white mt-24" data-testid="footer">
      <div className="max-w-[1280px] mx-auto px-4 sm:px-6 py-12">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-10">
          {/* About */}
          <div>
            <img src="/logo-footer.svg" alt="SitgesVibes" width="205" height="70" className="h-[70px] w-auto mb-4 -mt-[29px] -ml-[11px]" />
            <p className="text-sm text-white/60 leading-relaxed max-w-md -mt-[3px]">
              {t('footer_about_desc')}
            </p>
          </div>

          {/* External Links & Affiliate Disclosure */}
          <div>
            <h4 className="text-sm font-semibold mb-3">{t('footer_external_links_title')}</h4>
            <p className="text-sm text-white/60 leading-relaxed max-w-md">
              {t('footer_external_links_desc')}
            </p>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-semibold mb-3">{t('footer_contact_title')}</h4>
            <a
              href="mailto:info@sitgesvibes.com"
              className="text-sm text-white/60 hover:text-white transition-colors"
              data-testid="footer-contact-email"
            >
              info@sitgesvibes.com
            </a>
          </div>
        </div>

        <Separator className="my-8 bg-white/10" />

        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/40">
            &copy; {new Date().getFullYear()} SitgesVibes. {t('footer_rights')}
          </p>

          <nav className="flex flex-wrap items-center justify-center gap-x-2 gap-y-1 text-xs">
            {legalLinks.map((link, i) => {
              const isLast = i === legalLinks.length - 1;
              return (
                <React.Fragment key={link.key}>
                  <Link
                    to={link.href}
                    className="text-white/60 hover:text-white transition-colors"
                    data-testid={link.testId}
                  >
                    {t(link.key)}
                  </Link>
                  {isLast ? (
                    <span className="text-white/60">
                      (
                      <button
                        type="button"
                        onClick={handleResetConsent}
                        className="underline hover:text-white transition-colors"
                        data-testid="footer-link-reset-consent"
                      >
                        {t('reset_cookie_preferences')}
                      </button>
                      )
                    </span>
                  ) : (
                    <span className="text-white/30">·</span>
                  )}
                </React.Fragment>
              );
            })}
          </nav>
        </div>
      </div>
    </footer>
  );
}
